module.exports = __webpack_public_path__ + "img/card2.3435ad52.png";